import React from 'react';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';

const LoanPerformanceChart = ({ data }) => {
    if (!data || !data.byTerm || data.byTerm.length === 0) {
        return (
            <Card className="chart-card">
                <div className="chart-header">
                    <h3>Loan Performance</h3>
                    <div className="chart-subtitle">No data available</div>
                </div>
            </Card>
        );
    }

    const chartData = {
        labels: data.byTerm.map(item => item.category),
        datasets: [
            {
                label: 'Loan Amount',
                data: data.byTerm.map(item => item.amount || 0),
                backgroundColor: [
                    'rgba(66, 165, 245, 0.8)',
                    'rgba(102, 187, 106, 0.8)',
                    'rgba(255, 152, 0, 0.8)',
                    'rgba(156, 39, 176, 0.8)',
                    'rgba(244, 67, 54, 0.8)'
                ],
                borderColor: [
                    '#42A5F5',
                    '#66BB6A',
                    '#FF9800',
                    '#9C27B0',
                    '#F44336'
                ],
                borderWidth: 2
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: (value) => '₹' + value.toLocaleString()
                }
            }
        }
    };

    return (
        <Card className="chart-card">
            <div className="chart-header">
                <h3>Loan Performance by Term</h3>
                <div className="chart-subtitle">Total Active Loans: {data.totalActiveLoans || 0}</div>
            </div>
            <div className="chart-container">
                <Chart type="bar" data={chartData} options={options} />
            </div>
        </Card>
    );
};

export default LoanPerformanceChart;
